import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capitalizeFirstLetter } from "../../util/Utils";

export function UseMyPCDiscount(sortColumn, sortOrder) {
  const location = useLocation();

  const [myPcDiscount, setMyPcDiscount] = useState(
    location.state && location.state.myPcDiscount
      ? location.state.myPcDiscount
      : {
          page: 0,
          sortColumn: sortColumn || sortColumn == "" ? sortColumn : "Id",
          sortOrder: sortOrder || sortOrder == "" ? sortOrder : "Asc",
          searchColumn: "",
          scrollTo: undefined,
          forceRefresh: false,
        }
  );

  const goToLastPage = (lastPage) => {
    setMyPcDiscount({ ...myPcDiscount, page: lastPage, scrollTo: undefined });
  };

  const goToFirstPage = () => {
    setMyPcDiscount({ ...myPcDiscount, page: 1 });
  };

  const updatePage = (page) => {
    setMyPcDiscount({ ...myPcDiscount, page: page, scrollTo: undefined });
  };

  const updatSearchColumn = (col) => {
    setMyPcDiscount({
      ...myPcDiscount,
      searchColumn: col,
    });
  };

  const updateSort = (col, order) => {
    setMyPcDiscount({
      ...myPcDiscount,
      sortColumn: capitalizeFirstLetter(col),
      sortOrder: order,
      sorted: true,
    });
  };

  const setScrollTo = (value) => {
    myPcDiscount.scrollTo = value;
  };

  const refresh = () => {
    let page = myPcDiscount.page;
    if (page === 0) {
      page = 1;
    }
    setMyPcDiscount({
      ...myPcDiscount,
      forceRefresh: !myPcDiscount.forceRefresh,
      page: page,
    });
  };

  return {
    myPcDiscount,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
    updatSearchColumn,
  };
}
